<template>
  <div class="anexos-details">
    <page-header :title="title" />
    <page-section :group-label="'CNH'">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :value="tag.cnhLink"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('cnhLink')
            "
          >
            <template #value>
              <div v-if="tag.cnhLink" class="mt-2 d-inline">
                <v-btn
                  link
                  tag="a"
                  target="_blank"
                  :href="
                    $store.state.attachmentDocumentURL + 'cnh/' + tag.cnhLink
                  "
                  elevation="0"
                  small
                  color="blue lighten-1"
                  text
                >
                  <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                  {{ $t("visualizar") }}
                </v-btn>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="'RG/CPF'">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :value="tag.rgCpfLink"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('rgCpfLink')
            "
          >
            <template #value>
              <div v-if="tag.rgCpfLink" class="mt-2 d-inline">
                <v-btn
                  link
                  tag="a"
                  target="_blank"
                  :href="
                    $store.state.attachmentDocumentURL +
                    'rgCpf/' +
                    tag.rgCpfLink
                  "
                  elevation="0"
                  small
                  color="blue lighten-1"
                  text
                >
                  <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                  {{ $t("visualizar") }}
                </v-btn>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="'CRACHA'">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :value="tag.cartaoIdentLink"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('cartaoIdentLink')
            "
          >
            <template #value>
              <div v-if="tag.cartaoIdentLink" class="mt-2 d-inline">
                <v-btn
                  link
                  tag="a"
                  target="_blank"
                  :href="
                    $store.state.attachmentDocumentURL +
                    'cartaoIdent/' +
                    tag.cartaoIdentLink
                  "
                  elevation="0"
                  small
                  color="blue lighten-1"
                  text
                >
                  <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                  {{ $t("visualizar") }}
                </v-btn>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="'ASO'">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :value="tag.asoLink"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('asoLink')
            "
          >
            <template #value>
              <div v-if="tag.asoLink" class="mt-2 d-inline">
                <v-btn
                  link
                  tag="a"
                  target="_blank"
                  :href="
                    $store.state.attachmentDocumentURL + 'aso/' + tag.asoLink
                  "
                  elevation="0"
                  small
                  color="blue lighten-1"
                  text
                >
                  <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                  {{ $t("visualizar") }}
                </v-btn>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="'Data Expiração'"
            :value="tag.asoDataExpiracao | toLocaleDate"
          />
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="'Certificados'">
      <v-row no-gutters>
        <v-col v-if="tag.certificados.length <= 0">
          <small class="grey--text text--darken-1">
            <i>nenhum certificado encontrado</i>
          </small>
        </v-col>
        <v-col
          class="mb-4"
          cols="4"
          v-for="(item, i) in tag.certificados"
          :key="i"
        >
          <field-section
            :value="item"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('certificados')
            "
          >
            <template #value>
              <div v-if="item" class="mt-2 d-inline">
                <v-row class="px-0 mx-0">
                  <v-col cols="1" class="d-flex justify-center">
                    <v-icon size="36">mdi-file-certificate-outline</v-icon>
                  </v-col>
                  <v-col class="ma-0">
                    <div class="" style="font-size: 0.7rem">
                      {{ item.descricao | toPT_BRCapitalize }}
                    </div>
                    <v-btn
                      link
                      tag="a"
                      target="_blank"
                      :href="
                        $store.state.attachmentDocumentURL +
                        'certificate/' +
                        item.certificadoLink
                      "
                      elevation="0"
                      small
                      color="blue lighten-1"
                      text
                      class="pa-0 py-1"
                      style="font-size: 0.6rem; height: 18px"
                    >
                      <v-icon size="13" class="mr-1">mdi-open-in-new</v-icon>
                      {{ $t("visualizar") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="tag" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Anexos") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Anexos"),
  }),
  computed: {
    tag() {
      return this.$store.state.tagFuncionario.data || {};
    },
  },
};
</script>

<style scoped></style>
